import { Box } from '@mui/material';
import { LineupWidget } from 'src/components/widget/lineupWidget';
import { useUserRole } from 'src/utils';

import { SingleCategoryProductsProps } from './SingleCategoryProducts.interface';

export const SingleCategoryProducts = (props: SingleCategoryProductsProps) => {
  const { isOwnerOperator } = useUserRole();

  return (
    <Box sx={{ padding: '0 26px' }}>
      <LineupWidget
        group={props.group}
        groupNumber={props.groupNumber}
        showComponents={props.showComponents}
        componentType={props.componentType}
        productCategoryIDs={props.productCategoryIDs}
        themeId={props.themeId}
        handleGroupChange={props.handleGroupChange}
        componentConfig={props.componentConfig}
        hideDeleteButton={
          isOwnerOperator &&
          Object.keys(props.group?.products || {}).length === 1
        }
      />
    </Box>
  );
};
